import { render, staticRenderFns } from "./Limos_dialog.vue?vue&type=template&id=1b02c115&scoped=true&"
import script from "./Limos_dialog.vue?vue&type=script&lang=js&"
export * from "./Limos_dialog.vue?vue&type=script&lang=js&"
import style0 from "./Limos_dialog.vue?vue&type=style&index=0&id=1b02c115&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b02c115",
  null
  
)

export default component.exports